import { Component, HostListener, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ICalculationType, IClub, ICourt, IPayment, ISport, IState } from '../../models/club.model';
import { CoreService } from '../../services/core.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-club-popup',
  templateUrl: './club-popup.component.html',
  styleUrls: ['./club-popup.component.css'],
})
export class ClubPopupComponent {
  states: IState[] = [];
  sports: ISport[] = [];
  calculationTypes: any[] = [];
  courts: ICourt[] = [];
  club: IClub = {
    id: -1,
    clubName: '',
    address1: '',
    address2: '',
    city: '',
    zip: '',
    createdBy: '',
    payments: [],
    createdDate: new Date(),
    state: {
      id: -1,
      code: '',
      name: 'Select State'
    },
    sport: {
      id: -1,
      name: 'Select Sport'
    },
    homeCourt: {
      id: -1,
      name: 'Select Court'
    },
    calculationType: null
  };
  isCropSuccess = false;
  errorMessage: string = '';
  isMobile = window.innerWidth <= 768;

@HostListener('window:resize')
onResize() {
  this.isMobile = window.innerWidth <= 768;
}

  constructor(
    public dialogRef: MatDialogRef<ClubPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public existingClub: IClub,
    private coreService: CoreService
  ) {
    console.log('Existing club calcType:', this.existingClub?.calculationType);

    this.getStates();
    this.getSports();
    this.getcalculationTypes();

    const paymentOptions = ['Venmo', 'Zelle', 'Card Payment'];
    if (existingClub) {
      existingClub.state = existingClub?.state ? existingClub.state : this.club.state;
      // Always ensure all payment options are present
      existingClub.payments = paymentOptions.map(option => {
        return (
          existingClub.payments?.find(p => p.paymentOption === option) || {
            paymentOption: option,
            checked: false,
            payTo: ''
          }
        );
      }) as IPayment[];
      this.club = { ...this.club, ...existingClub, payments: existingClub.payments };
    } else {
      // For create, always initialize all payment options
      this.club.payments = paymentOptions.map(option => ({ paymentOption: option, checked: false, payTo: '' }));
    }

    this.getCourts();
  }


  isAtLeastOnePaymentUploaded(): boolean {
    return !!this.club.payments?.some(payment => payment.checked);
  }

  isPayToNotAdded(): boolean {
    return !!((this.club.payments?.[0].checked && !this.club.payments?.[0].payTo) || (this.club.payments?.[1].checked && !this.club.payments?.[1].payTo));
  }

  getPaymentOption(option: string): IPayment {
    const payment = this.club.payments?.find(p => p.paymentOption === option);
    if (!payment) {
      throw new Error(`Payment option '${option}' not found`);
    }
    return payment;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  isSubmitDisabled(form: NgForm): boolean {
    return (
      form.invalid ||
      this.club.state.id === -1 ||
      this.club.sport.id === -1 ||
      this.club.homeCourt.id === -1 ||
      !this.isAtLeastOnePaymentUploaded() ||
      this.isPayToNotAdded() ||
      !!this.errorMessage
    );
  }


  getCourts() {
    this.coreService.isLoading.next(true);
    this.coreService.getApi(`/api/Court/GetCourtsBySport?sportId=${this.club.sport.id}`).subscribe({
      next: (res: any) => {
        this.coreService.isLoading.next(false);
        this.courts = res;
      },
      error: () => {
        this.coreService.isLoading.next(false);
      },
    });
  }

  getStates() {
    this.coreService.isLoading.next(true);
    this.coreService.getApi('/api/Master/GetStates').subscribe({
      next: (res: any) => {
        this.coreService.isLoading.next(false);
        this.states = res;
      },
      error: () => {
        this.coreService.isLoading.next(false);
      },
    });
  }

  getSports() {
    this.coreService.isLoading.next(true);
    this.coreService.getApi('/api/Master/GetSports').subscribe({
      next: (res: any) => {
        this.coreService.isLoading.next(false);
        this.sports = res;
      },
      error: () => {
        this.coreService.isLoading.next(false);
      },
    });
  }
getcalculationTypes() {
  this.coreService.getApi('/api/Club/GetCalculationTypes').subscribe({
    next: (res: ICalculationType[]) => {
      this.calculationTypes = res;

      if (!this.existingClub?.calculationType) {
        console.warn('No calculationType from backend');
        return;
      }

      // handle string OR object
      const typeValue =
        typeof this.existingClub.calculationType === 'string'
          ? this.existingClub.calculationType
          : this.existingClub.calculationType.type;

      this.club.calculationType =
        this.calculationTypes.find(ct => ct.type === typeValue) || null;
    }
  });
}


compareCalculationType(a: any, b: any): boolean {
  return a && b ? a.id === b.id : a === b;
}

 
}
